import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { telnyxNumbersApi } from '@/lib/api/telnyx-numbers.api';

import type { TelnyxAssignInboundNumberDto } from '@repo/shared-types';

const TELNYX_NUMBERS_QUERY_KEY = ['telnyx-numbers'];

export function useTelnyxNumbers() {
  return useQuery({
    queryKey: TELNYX_NUMBERS_QUERY_KEY,
    queryFn: () => telnyxNumbersApi.list(),
  });
}

export function useSyncTelnyxNumbers() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => telnyxNumbersApi.sync(),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: TELNYX_NUMBERS_QUERY_KEY });
    },
  });
}

export function useAssignInboundTelnyxNumber() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      numberId,
      payload,
    }: {
      numberId: string;
      payload: TelnyxAssignInboundNumberDto;
    }) => telnyxNumbersApi.assignInbound(numberId, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: TELNYX_NUMBERS_QUERY_KEY });
      queryClient.invalidateQueries({ queryKey: ['configurations'] });
    },
  });
}
